import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import Loader from './Loader';
import { CalendarMonth, Campaign, Event } from '@mui/icons-material';
import { Link } from 'react-router-dom';
 
const BASE_FILE = process.env.NEXT_PUBLIC_FILE_SERVER_URL || "https://appserver.tbzmc.com";

const LatestNews = ({ limit = 7 }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        setLoading(true);
        const [newsRes, eventsRes] = await Promise.allSettled([
          api.get('/news/recent', { params: { limit: 10 } }),
          api.get('/events', { params: { limit: 10 } })
        ]);

        let combined = [];

        if (newsRes.status === 'fulfilled') {
          const newsList = (newsRes.value.data || []).map(item => ({
            ...item,
            _type: 'news',
            displayDate: item.createdAt ? new Date(item.createdAt).toLocaleDateString('fa-IR') : ''
          }));
          combined.push(...newsList);
        }

        if (eventsRes.status === 'fulfilled') {
          const eventsData = eventsRes.value.data;
          const eventsList = (Array.isArray(eventsData) ? eventsData : eventsData?.events || []).map(item => ({
            ...item,
            _type: 'event',
            displayDate: item.date || ''
          }));
          combined.push(...eventsList);
        }

        // Sort by date (descending) - assuming newer items are better
        combined.sort((a, b) => {
          const dateA = new Date(a.createdAt || 0);
          const dateB = new Date(b.createdAt || 0);
          return dateB - dateA;
        });

        setItems(combined.slice(0, limit));
      } catch (e) {
        console.error('Error loading news and events', e);
        setItems([]);
      } finally { setLoading(false); }
    };
    fetchItems();
  }, [limit]);

  if (loading) return <Loader />;
  if (!items || items.length === 0) return null;

  return (
    <div className="mb-3 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">خبر و رویداد جدید</h6>
        <div className="d-flex gap-2">
          <Link to="/news" className="size-12 text-primary text-decoration-none">همه اخبار</Link>
          <span className="text-muted size-12">|</span>
          <Link to="/events" className="size-12 text-primary text-decoration-none">همه رویدادها</Link>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, overflowX: 'auto', paddingBottom: 8, WebkitOverflowScrolling: 'touch' }}>
        {items.map(item => {
          const isNews = item._type === 'news';
          const link = isNews ? `/newsdetail/${item._id}` : `/eventdetail/${item._id}`;
          const image = isNews ? item.image : item.posterImage;

          return (
            <Link
              to={link}
              key={item._id}
              className="text-decoration-none"
              style={{ flex: '0 0 220px' }}>
              <div className="card mb-0 shadow-sm border-0 h-100">
                <div className="position-relative">
                  {image ? (
                    <img
                      src={`${BASE_FILE}/uploads/documents/${image}`}
                      alt={item.title}
                      style={{ height: 120, objectFit: 'cover', width: '100%', borderTopRightRadius: 15, borderTopLeftRadius: 15 }}
                    />
                  ) : (
                    <div className="bg-light d-flex align-items-center justify-content-center" style={{ height: 120, width: '100%', borderTopRightRadius: 15, borderTopLeftRadius: 15 }}>
                      {isNews ? <Campaign color="disabled" sx={{ fontSize: 40 }} /> : <Event color="disabled" sx={{ fontSize: 40 }} />}
                    </div>
                  )}
                  <span className={`badge ${isNews ? 'bg-primary' : 'bg-warning text-dark'} position-absolute top-0 end-0 m-2 size-10`}>
                    {isNews ? 'خبر' : 'رویداد'}
                  </span>
                </div>
                <div className="card-body p-2">
                  <h6 className="small mb-1 text-dark" style={{
                    height: 40,
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                  }}>{item.title}</h6>
                  <div className="size-10 text-muted d-flex align-items-center" >
                    <CalendarMonth sx={{ fontSize: 14 }} className="me-1" />
                    {item.displayDate}
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default LatestNews;
